import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';

import { createLogger } from 'redux-logger';

import rootReducer from './reducers';
import lockerMiddleware from './lib/locker-middleware';
import analyticsMiddleware from './lib/analytics-middleware';

import { BASE_NAME_APP, STORE_LOGGER } from './config';
import { CLASSWORK_LOGIN_CORRECTION, EXERCISE_PREVIEW } from './constants/routes';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['appLoading', 'googleAuth'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// creato store
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => {
        const middlewares = getDefaultMiddleware().concat(lockerMiddleware).concat(analyticsMiddleware);
        if (STORE_LOGGER) {
            middlewares.push(createLogger({ collapsed: true, diff: true }));
        }
        return middlewares;
    },
});
export const persistor = persistStore(store);

// pulisce lo store se l'url contiene un payload
const urlParams = new URLSearchParams(window.location.search);
const baseNameApp = BASE_NAME_APP ?? '';
if (
    (urlParams && !!urlParams.get('payload')) ||
    window.location.pathname === CLASSWORK_LOGIN_CORRECTION ||
    window.location.pathname.startsWith(`${baseNameApp}${EXERCISE_PREVIEW}`)
) {
    persistor.purge();
}
